import { httpDelete, httpGet } from "./index";

const enc = (value: string) => encodeURIComponent(String(value));

export const getOAuthDynamicClients = async (serverId: string) => {
  return httpGet(`/mcp-servers/${enc(serverId)}/clients`, {});
};

// CIMD client IDs are URLs, so they never travel in a path segment: the edge proxy
// decodes %2F back to "/" and 307-redirects, which fails the browser's CORS
// preflight. Reads pass the id as a query param, writes in the body — matching
// revokeUserConnection below.
export const deleteOAuthDynamicClient = async (serverId: string, clientId: string) => {
  return httpDelete(`/mcp-servers/${enc(serverId)}/client`, {}, { clientId });
};

export const getOAuthDynamicClientUsers = async (serverId: string, clientId: string) => {
  return httpGet(`/mcp-servers/${enc(serverId)}/client-users`, { clientId });
};

export const revokeOAuthDynamicClientUser = async (serverId: string, clientId: string, uid: string) => {
  return httpDelete(`/mcp-servers/${enc(serverId)}/client-users/${enc(uid)}`, {}, { clientId });
};

// User-scoped consent (Customer Details -> Account Info -> Connections).
export const getUserConnections = async (uid: string) => {
  return httpGet(`/customer-management/connections`, { uid });
};

export const revokeUserConnection = async (uid: string, clientId: string, parentClientId: string) => {
  return httpDelete(`/customer-management/connections`, {}, { uid, clientId, parentClientId });
};
